export const isPlayersSet = (store) => store.player_1 && store.player_2;